import { render, staticRenderFns } from "./Zonas.vue?vue&type=template&id=201dfe9a&"
import script from "./Zonas.vue?vue&type=script&lang=ts&"
export * from "./Zonas.vue?vue&type=script&lang=ts&"
import style0 from "./Zonas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports